import SocialFeed, { SocialFeedTemplate } from "@esign/social-feed";

export default function () {
  const socialFeedContainer = document.querySelector(".js-social-feed");

  // social media
  const pictureSources = (srcsets) => {
    let picture = "";

    Object.entries(srcsets).forEach(([, value]) => {
      picture = `${picture}<source media="${value.mediaQuery}" srcset="${value.url}" type="image/${value.extension}">`;
    });

    return picture;
  };

  if (socialFeedContainer) {
    // Get the type from the data attribute
    const type = socialFeedContainer.getAttribute("data-feed-type");
    new SocialFeed({
      gridClass: `grid grid--small ${
        type === "fullscreen" ? "grid--gutter-0" : "grid--social-regular"
      } social-grid`,
      itemClass: "grid__item one-half medium--one-half large--one-quarter",
      template: new SocialFeedTemplate({
        itemTemplate: (item) =>
          `<div class="grid__item one-half medium--one-half large--one-quarter">
          <a href="${
            item.url
          }" target="_blank" class="social-grid__item link social-item-link" rel="nofollow">
            <div class="social-grid__item-content">
              <p>${item.body}</p>
            </div>
            <div class="visual ${ item.media_type === "video" ? `visual--video` : `` }">
              ${
                (item.media_type === "image" ||
                  item.media_type === "CAROUSEL_ALBUM") &&
                item.photo &&
                item.srcsets.length
                  ? `<picture>
                      ${pictureSources(item.srcsets)}
                      <img loading="lazy" src="${item.photo}" alt=""/>
                    </picture>`
                  : ""
              }
              ${
                (item.media_type === "image" ||
                  item.media_type === "CAROUSEL_ALBUM") &&
                item.photo &&
                !item.srcsets.length
                  ? `<img loading="lazy" src="${item.photo}" alt="" />`
                  : ""
              }
              ${
                item.media_type === "video" && item.photo
                  ? `<video autoplay playsinline muted loop>
                      <source src="${item.photo}" type="video/mp4">
                    </video>`
                  : ""
              }
            </div>
          </a>
        </div>`,
      }),
    });
  }
}
